<template>
  <v-container fluid>
    <v-row align="stretch">
      <!-- Main Welcome Card -->
      <v-col cols="12" md="8">
        <v-card elevation="1" class="welcome-card overflow-hidden rounded-lg">
          <v-row no-gutters align="center">
            <v-col cols="12" md="6" class="welcome-text-section">
              <div class="pa-8">
                <v-chip color="rgba(255,255,255,0.12)" text-color="white" label small class="badge-chip mb-4">
                  <v-icon left small>mdi-account-heart-outline</v-icon>
                  HR Management System
                </v-chip>

                <h1 class="welcome-title mb-2">Welcome Back!</h1>

                <h2 class="department-title mb-4">
                  สำนักอำนวยการ<br>
                  <span class="highlight-text">กลุ่มงานจัดการบุคคล</span>
                </h2>

                <div>
                  <v-chip
                    v-for="tag in ['Modern', 'Efficient', 'Secure']"
                    :key="tag"
                    small
                    outlined
                    color="white"
                    class="mr-2 mb-2 tag-chip"
                  >
                    {{ tag }}
                  </v-chip>
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="6" class="image-section">
              <div class="pa-6 image-container">
                <v-img class="main-image" src="hrovec.png" height="220px" contain />
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>

      <!-- Login Card -->
      <v-col cols="12" md="4">
        <v-card class="login-card h-100 rounded-lg" elevation="1">
          <div class="login-content text-center pa-8">
            <div class="logo-background mb-6">
              <v-img src="hrvec.png" height="64px" contain />
            </div>

            <div class="login-message mb-6">
              <h3 class="login-title mb-2">เข้าสู่ระบบ</h3>
              <p class="login-subtitle">ยินดีต้อนรับสู่ระบบกลุ่มงานจัดการบุคคล</p>
            </div>

            <v-btn to="/pages/login" large block depressed class="login-btn">
              <v-icon left>mdi-login-variant</v-icon>
              เข้าสู่ระบบ
            </v-btn>

            <div class="quick-stats mt-8">
              <v-row>
                <v-col cols="6" class="text-center">
                  <div class="stat-item">
                    <v-icon color="#2b6cb0" size="24" class="mb-1">mdi-account-multiple-outline</v-icon>
                    <div class="stat-number">{{ periods.length || '---' }}</div>
                    <div class="stat-label">Periods</div>
                  </div>
                </v-col>
                <v-col cols="6" class="text-center">
                  <div class="stat-item">
                    <v-icon color="#38a169" size="24" class="mb-1">mdi-check-circle-outline</v-icon>
                    <div class="stat-number">100%</div>
                    <div class="stat-label">Uptime</div>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "OcsMasterWelcome",
  data() {
    return {
      ApiKey: "mouovec2024",
      periods: []
    };
  },
  async mounted() {
    await this.periodQuery();
  },
  methods: {
    async periodQuery() {
      try {
        let result = await this.$http.post("period.php", {
          ApiKey: this.ApiKey
        });
        this.periods = result.data;
      } catch (error) {
        console.error('Error fetching periods:', error);
      }
    }
  }
};
</script>

<style scoped>
/* Welcome Card */
.welcome-card {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.welcome-text-section {
  background: #1a365d;
  color: white;
  min-height: 320px;
  display: flex;
  align-items: center;
}

.badge-chip {
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.welcome-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #ffffff;
}

.department-title {
  font-size: 1.3rem;
  font-weight: 600;
  line-height: 1.3;
  color: rgba(255, 255, 255, 0.9);
}

.highlight-text {
  color: #f6ad55;
  font-weight: 700;
}

.tag-chip {
  border-color: rgba(255, 255, 255, 0.35) !important;
  color: rgba(255, 255, 255, 0.9) !important;
}

/* Image Section */
.image-section {
  background: #f7fafc;
}

.image-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.main-image {
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.08));
}

/* Login Card */
.login-card {
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}

.login-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.logo-background {
  width: 96px;
  height: 96px;
  background: #f7fafc;
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  padding: 12px;
}

.login-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2d3748;
}

.login-subtitle {
  color: #718096;
  margin: 0;
  font-size: 0.9rem;
}

.login-btn {
  background: #2b6cb0 !important;
  color: white !important;
  font-weight: 600;
  text-transform: none;
  font-size: 1.05rem;
  height: 52px !important;
  border-radius: 10px !important;
  transition: background 0.2s ease;
}

.login-btn:hover {
  background: #2c5282 !important;
}

/* Quick Stats */
.stat-item {
  padding: 16px;
  border-radius: 10px;
  background: rgba(43, 108, 176, 0.05);
}

.stat-number {
  font-size: 1.4rem;
  font-weight: 700;
  color: #2d3748;
}

.stat-label {
  font-size: 0.8rem;
  color: #718096;
}

/* Responsive */
@media (max-width: 960px) {
  .welcome-title {
    font-size: 2rem;
  }

  .department-title {
    font-size: 1.15rem;
  }

  .welcome-text-section {
    min-height: auto;
  }

  .login-content {
    padding: 24px !important;
  }
}

@media (max-width: 600px) {
  .welcome-title {
    font-size: 1.7rem;
  }

  .department-title {
    font-size: 1rem;
  }
}
</style>
